import { Injectable } from '@angular/core';

export interface BadgeItem {
    type: string;
    value: string;
}
export interface Saperator {
    name: string;
    type?: string;
}
export interface SubChildren {
    state: string;
    name: string;
    type?: string;
}
export interface ChildrenItems {
    state: string;
    name: string;
    type?: string;
    child?: SubChildren[];
    /** Lower-case roles that may see this entry; omitted = everyone. */
    roles?: string[];
}

export interface Menu {
    state: string;
    name: string;
    type: string;
    icon: string;
    badge?: BadgeItem[];
    saperator?: Saperator[];
    children?: ChildrenItems[];
    /** Lower-case roles that may see this entry; omitted = everyone. */
    roles?: string[];
}

const MENUITEMS = [
    // {
    //     state: '',
    //     name: 'Personal',
    //     type: 'saperator',
    //     icon: 'av_timer'
    // },
    {
    state: 'admin',
        name: 'Administration',
        type: 'sub',
        icon: 'admin_panel_settings',
        code:'Admin',
        children: [
          { state: 'manage', name: 'Add/Select', type: 'link',code:'Admin' },
          { state: 'scalescuts', name: 'Scales and Cuts', type: 'link', code: 'Admin' }
        ]
  },
  {
    state: 'analysis',
    name: 'Analysis',
    type: 'sub',
    icon: 'trending_up',
    code: 'Admin',
    children: [
      { state: 'manage', name: 'Add/Select', type: 'link', code: 'Admin' },
      { state: 'analyze', name: 'Analyze', type: 'link',code:'Analyze' }
    ]
  },
  {
    state: 'scoring',
    name: 'Scoring',
    type: 'sub',
    icon: 'speed',
    code: 'Admin',
    children: [
      { state: 'manage', name: 'Create Lookup Tables', type: 'link', code: 'Admin' },
      { state: 'score', name: 'Score', type: 'link', code: 'Score' }
    ]
  },
  {
    state: 'pools',
    name: 'Pool Publication',
    type: 'sub',
    icon: 'inventory_2',
    code: 'Admin',
    roles: ['systemadmin', 'psychometrician', 'admin'],
    children: [
      { state: 'manage', name: 'Pools', type: 'link', code: 'Admin' },
      { state: 'consumers', name: 'Consumers', type: 'link', code: 'Admin', roles: ['systemadmin'] }
    ]
  },
  {
    state: '',
    name: 'Help',
    type: 'window',
    icon: 'help',
    code: "Help",
  }
   
];

@Injectable()
export class MenuItems {
    getMenuitem(): Menu[] {
        return MENUITEMS;
    }
}
